'use client'
import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player/lazy'

import { addParagraphs } from '@/src/formatter'

const FeedContent = ({ content, isSelf }) => {
  const ref = React.createRef()
  const [showMore, setShowMore] = useState(false)
  const [videoUrls, setVideoUrls] = useState([])

  const checkForVideos = async (content) => {
    if (!content) return
    const EXP = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
    const urls = content.match(EXP) || []
    const vUrls = []
    for (let url of urls) {
      if (url.match('youtube.com') || url.match('youtu.be') || url.match('vimeo.com')) {
        vUrls.push(url)
      }
    }
    setVideoUrls(vUrls)
  }

  useEffect(() => {
    checkForVideos(content)
  }, [content])
  
  const toggleShowMore = () => {
    if (!showMore) setShowMore(!showMore)
  }

  return <>
    {videoUrls && Boolean(videoUrls.length) && <div className='mt-2 px-2 mb-2'>
      {videoUrls.map((url) => <div key={url}>
        <div className='md:hidden'><ReactPlayer height={172} width={300} url={url} controls={true} /></div>
        <div className='hidden md:block'><ReactPlayer height={338} width={600} url={url} controls={true} /></div>
      </div>)}
    </div>}

    {content && (
      <div 
        ref={ref}
        onClick={toggleShowMore}  
        className={`break-word [&_a]:break-all [overflow-wrap:anywhere] text-lg text-wrap ${showMore ? '' : 'max-h-[5em] line-clamp-3'} overflow-hidden ${!isSelf ? 'text-chTan-900' : ''}`} 
      >
        {addParagraphs(content)}
      </div>
    )}
  </>
}

export default FeedContent